import { EntityId } from '@reduxjs/toolkit'

export type Attribute = {
  id: EntityId
  clientId: EntityId
  attributeType: typeof AttributeTypeEnum.Order | typeof AttributeTypeEnum.Vehicle
  name: string
  description: string
  hasConstraints: boolean
}

export const AttributeTypeEnum = {
  Order: 1,
  Vehicle: 2,
}